import { Delete } from "@mui/icons-material";
import { SwipeAction, TrailingActions } from "react-swipeable-list";

type RightActionProps = {
	onDelete: () => void;
};

const RightAction = ({ onDelete }: RightActionProps) => {

	return (
		<TrailingActions>
			<SwipeAction
                onClick={onDelete}
            >
                <div 
                    style={{ 
                        display: 'flex',
                        width: 100,
                        backgroundColor: 'red', 
                        justifyContent: 'center', 
                        alignItems: 'center',
                        cursor: 'pointer'
                    }}
                >
                    <Delete sx={{ color: 'white' }}/>
                </div>
            </SwipeAction>
		</TrailingActions>
	);
};

export default RightAction;